
<template>
  <div>
    <page-head :title="title" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="titles box ac">
        <span class="iconfont icon-shijianxiangqing"></span>
        <span>业务详情</span>
      </div>
      <div class="infobox">
        <div class="infolistbox">
          <div class="infolist box ac">
            <div class="infolistleft box ac">
              <span>单号：</span>
              <span>{{info.orderNO}}</span>
            </div>
          </div>
        </div>
        <div class="lines"></div>
        <div class="infolistbox">
           <div class="infolist box ac">
             <div class="infolistleft box ac">
               <span>报装企业名称：</span>
               <span>{{info.businessName}}</span>
             </div>
             <div class="infolistleft box ac">
               <span>企业性质：</span>
               <span>{{info.businessNature}}</span>
             </div>
           </div>
           <div class="infolist box ac">
             <div class="infolistleft box ac">
               <span>组织结构代码：</span>
               <span>{{info.organizationStructureCode}}</span>
             </div>
             <div class="infolistleft box ac">
               <span>报装地址：</span>
               <span>{{info.address}}</span>
             </div>
           </div>
        </div>
        <div class="lines"></div>
        <div class="infolistbox">
           <div class="infolist box ac">
             <div class="infolistleft box ac">
               <span>申请人：</span>
               <span>{{info.userName}}</span>
             </div>
             <div class="infolistleft box ac">
               <span>申请人身份证号：</span>
               <span>{{info.idCardNO}}</span>
             </div>
           </div>
           <div class="infolist box ac">
             <div class="infolistleft box ac">
               <span>申请人电话：</span>
               <span>{{info.phoneNO}}</span>
             </div>
           </div>
        </div>
        <div class="lines"></div>
        <div class="infolistbox">
           <div class="infolist box ac">
             <div class="infolistleft box ac">
               <span>业务名称：</span>
               <span>{{info.bizType=="01"?"供电":info.bizType=="02"?"燃气":info.bizType=="03"?"供水":info.bizType=="04"?"供暖":info.bizType=="05"?"有线电视":info.bizType=="06"?"宽带":info.bizType=="07"?"固话":""}}</span>
             </div>
             <div class="infolistleft box ac">
               <span>预约日期：</span>
               <span>{{info.appointmentDate}}</span>
             </div>
             <!-- <div class="infolistleft box ac">
               <span>所属公司：</span>
               <span>{{info.company}}</span>
             </div> -->
           </div>
           <div class="infolist1">
              <div class="infotitles">企业组织机构代码：</div>
              <div class="imgbox">
                 <el-image
                   v-for="(item, index) in structureCodeUrl" :key="index"
                   :src="item"
                   :preview-src-list="structureCodeUrl"
                   style="width: 200px;height: 200px;margin-top:10px;margin-left:20px;"
                 />
              </div>
           </div>
           <div class="infolist1">
              <div class="infotitles">法人身份证复印件：</div>
              <div class="imgbox">
                 <el-image
                   v-for="(item, index) in legalPersonIdcardUrl" :key="index"
                   :src="item"
                   :preview-src-list="legalPersonIdcardUrl"
                   style="width: 200px;height: 200px;margin-top:10px;margin-left:20px;"
                 />
              </div>
           </div>
           <div class="infolist1" v-if="info.bizType=='02'">
              <div class="infotitles">房产证明：</div>
              <div class="imgbox">
                 <el-image
                   v-for="(item, index) in imgList" :key="index"
                   :src="item"
                   :preview-src-list="imgList"
                   style="width: 200px;height: 200px;margin-top:10px;margin-left:20px;"
                 />
              </div>
           </div>

        </div>
      </div>

      <div class="titles box ac">
        <span class="iconfont icon-shijianshangbao"></span>
        <span>上报</span>
      </div>
      <div class="infobox1">
        <div class="infopeople box ac">
          <div class="infopeopleleft box ac">
            <img class="infolog" src="../../../assets/images/default.png" />
            <div class="leftinfo">
              <span>姓名：{{info.userName}}</span><span>所属组织：</span>
            </div>
          </div>
          <div class="leftinfo" style="margin-left: 20px;">
            <span>提交时间：{{info.createTime}}</span>
            <span></span>
          </div>
        </div>
      </div>

      <div class="titles box ac">
        <span class="iconfont icon-shijianjieshou"></span>
        <span>部门办理</span>
      </div>
      <div class="infobox2">
        <div class="infobumen box">
          <div class="infobumenleft box ac ">
            <img class="infolog" src="../../../assets/images/default.png" />
            <div class="leftinfo">
              <span>姓名：{{info.handlingPerson?info.handlingPerson:defaultuser}}</span><span>所属部门：{{info.company}}</span>
            </div>
          </div>
          <div class="infobumenright box_f1" v-if="info.handlingStatus==1">
            <div><span>是否办理成功：</span><span>办理中</span></div>
            <div><span>办理结果：</span><span>办理中</span></div>
          </div>
          <div class="infobumenright box_f1" v-if="info.handlingStatus==3">
            <div><span>是否办理成功：</span><span>办理失败</span></div>
            <div><span>办理结果：</span><span>{{info.message}}</span></div>
          </div>
          <div class="infobumenright1 box_f1" v-if="info.handlingStatus==2">
            <div><span>是否办理成功：</span><span>办理成功</span></div>
            <div><span>办理结果：</span><span>{{info.message}}</span></div>
          </div>
          <div class="infobumenright2" v-if="info.handlingStatus==0||!info.handlingStatus">
            <div class="checkbox">
              <div class="checklable"><span>是否办理成功:</span></div>
              <div class="checkitem">
                <RadioGroup v-model="checkstatus" @on-change="radioGroupchange">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="textbox">
              <div class="checklable">办理结果：</div>
              <div class="textboxinfo">
                  <Input class="infotext" v-model="checkresult" maxlength="500" show-word-limit type="textarea" placeholder="请输入办理结果"  />
              </div>
            </div>
          </div>
        </div>
        <div class="btnbox" v-if="info.handlingStatus==0||!info.handlingStatus" @click="dook"><span>办理</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
  getwaterdetail,getwatersenddata,getwatersave,selectCompanyLifeBusinessDetails,handleCompanyLife
} = api;
export default {
  name: "newStudentsDetail",
  components: {
    pageHead
  },
  data() {
    return {
      structureCodeUrl:[],
      legalPersonIdcardUrl:[],
      imgList:[],
      defaultuser:window.sessionStorage.getItem("userName"),
	    id:"",
      bizTypelist: [
        {index:"01",type: "供电"},
        {index:"02",type: "燃气"},
        {index:"03",type: "供水"},
        {index:"04",type: "供暖"},
        {index:"05",type: "有线电视"},
        {index:"06",type: "宽带"},
        {index:"07",type: "固话"},
      ],
      info:{},
      checkresult:'',
      dostatus:0,
      title: "事件详情",
      btnList:[],
      // btnList: [{name: "导出本工单",type: "export"}],
      checkstatus: '是'
    };
  },
  methods: {
    async dook(){
      if(!this.checkresult){
        this.$Message.success("请输入办理结果");
        return ;
      }
      let data={
        "orderNO":this.orderNO,
        "id":this.id,
        "handlingPerson":window.sessionStorage.userName,
        "handlingStatus":this.checkstatus=="是"?2:3,
        "message":this.checkresult
      }
      let res = await this.$post(handleCompanyLife,data);
      console.log(res);
      if(res.isSucceed){
        this.getinfo()
      }
    },
    radioGroupchange(e){
      console.log(this.checkstatus)
    },
    handleBtn(type) {
      if (type == "export") {//导出

      }
    },
    async getinfo(){
      let url=selectCompanyLifeBusinessDetails+this.id
      let res = await this.$post(url);
      console.log(res);
      if(res.isSucceed&&res.rows&&res.rows.length>0){
        this.info=res.rows[0]
        if(this.info.estateImageUrl){
          this.imgList=JSON.parse(this.info.estateImageUrl)
        }
        if(this.info.structureCodeUrl){
          this.structureCodeUrl=JSON.parse(this.info.structureCodeUrl)
        }
        if(this.info.estateImageUrl){
          this.legalPersonIdcardUrl=JSON.parse(this.info.legalPersonIdcardUrl)
        }
      }
    },
    isInArray(arr,value){
        for(var i = 0; i < arr.length; i++){
            if(value === arr[i]){
                return true;
            }
        }
        return false;
    }
  },
  created() {
    let {orderNO,id} = this.$route.query;
    this.id=id
    this.orderNO=orderNO
    this.getinfo()
  }
};
</script>

<style  scoped lang="less">
.content{margin:0 20px 20px 20px;background: #FFFFFF;}
.titles{width: 100%;height: 58px;background: #F9F9F9;border-radius: 4px 4px 0px 0px;}
.titles span:nth-child(1){font-size: 16px;color: #FF7D44;margin-left: 20px;}
.titles span:nth-child(2){font-size: 16px;color: #333333;margin-left: 9px;}
.infobox{width: 100%;padding: 10px 0;}
.infolistbox{width: 100%;padding: 10px 0;}
.infolist{width: 100%;}
.lines{width:96%;margin-left: 20px;height: 1px;background: #FFAF00;border: 1px solid #DCDEE2;}
.infolistleft{width: 589px;height: 34px;line-height: 34px;}
.infolistleft span:nth-child(1){font-size: 14px;color: #666666;font-weight: 400;margin-left: 20px;}
.infolistleft span:nth-child(2){font-size: 14px;color: #666666;font-weight: 400;margin-left: 10px;}

.infobox1{width: 100%;padding: 30px 0;}
.infopeople{width: 100%;height: 96px;}
.infopeopleleft{width: 589px;height: 34px;}
.infolog{width: 96px;height: 96px;border-radius: 50%;margin-left: 20px;}
.leftinfo{height: 96px;margin-left: 29px;display: flex;display: -webkit-flex;flex-direction: column;}
.leftinfo span{height: 30px;line-height: 30px;font-size: 16px;color: #666666;font-weight: 400;}
.infobox2{width: 100%;padding:50px 0;position: relative;}
.infobumen{width: 100%;}
.infobumenleft{width:589px;}
.infobumenright{margin-left: 29px;display: flex;display: -webkit-flex;flex-direction: column;margin-right: 30px;}
.infobumenright div{line-height: 30px;font-size: 16px;color: #4B4B4B;font-weight: 400;}
.infobumenright div span:nth-child(2){color:#FF2A2C;}
.infobumenright div:nth-child(2){margin-top: 20px;}
.infobumenright1{margin-left: 29px;display: flex;display: -webkit-flex;flex-direction: column;margin-right: 30px;}
.infobumenright1 div{line-height: 30px;font-size: 16px;color: #4B4B4B;font-weight: 400;}
.infobumenright1 div span:nth-child(2){color:#07B55E;}
.infobumenright1 div:nth-child(2){margin-top: 20px;}
.infobumenright2{margin-left: 29px;display: flex;display: -webkit-flex;flex-direction: column;}
.checkbox{display: flex;display: -webkit-flex;align-items: center;}
.checklable{font-size: 16px;color: #4B4B4B;line-height: 30px;}
.checkitem{height: 30px;}
.ivu-radio-group-item{margin-left:50px;}
.textbox{margin-top:10px;}
.textboxinfo{}
.btnbox{position: absolute;top: 20px;right: 15px;width: 60px;
height: 28px;
background: #FF7D44;
border-radius: 4px;text-align: center;line-height: 28px;color: #FFFFFF;}
.infotitles{width: 589px;height: 34px;line-height: 34px;font-size: 14px;color: #666666;font-weight: 400;margin-left: 20px;}
.imgbox{width: 100%;display: flex;display: -webkit-flex;flex-wrap: wrap;padding-bottom: 20px;}
.imgbox img{width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;}
</style>
